import { useMemo } from "react";
import { ReactComponent as MoneyIcon } from "../../../assets/icons/moneys.svg";
import { Separator } from "../../../components/ui/common";
import DashboardCard from "../../../components/ui/dashboard/DashboardCard";
import { formatCurrency } from "../../../lib/utils";
import { useGetCompanyFinanceSummaryQuery } from "../financeApiSlice";

const FinanceStats: React.FC = () => {
  const { data, isLoading } = useGetCompanyFinanceSummaryQuery();

  const financeSummary = useMemo(() => {
    return (
      data?.data || {
        totalIncome: 0,
        totalExpense: 0,
        profit: 0,
        startDate: "",
        endDate: "",
        driverId: "",
        vehicleId: "",
        category: "",
      }
    );
  }, [data]);

  const cards = [
    {
      label: "Net banked",
      value: formatCurrency(financeSummary.profit),
      index: 0,
      icon: <MoneyIcon className="h-8 w-8 text-primary" />,
    },
    {
      label: "Total income",
      value: formatCurrency(financeSummary.totalIncome),
      index: 1,
      icon: <MoneyIcon className="h-8 w-8 text-green-500" />,
    },
    {
      label: "Total expense",
      value: formatCurrency(financeSummary.totalExpense),
      index: 2,
      icon: <MoneyIcon className="h-8 w-8 text-red-500" />,
    },
  ];

  return (
    <div className="flex flex-wrap gap-x-4 gap-y-4 sm:gap-x-10 sm:gap-y-6 bg-white rounded-[10px] p-4">
      {cards.map(({ label, value, index, icon }) => (
        <>
          <DashboardCard
            key={index}
            icon={icon}
            value={isLoading ? "0" : value}
            label={label}
            className="w-[300px]"
          />

          {index < cards?.length - 1 && <Separator />}
        </>
      ))}
    </div>
  );
};

export default FinanceStats;
